var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteAllIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1652_1176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.48523 7.86771L8.83507 17.6772L9.82258 17.6473L9.47274 7.83789L8.48523 7.86771Z",
    fill: "#E51A32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1786 17.6446L15.1679 17.6745L15.5177 7.86581L14.5284 7.83594L14.1786 17.6446Z",
    fill: "#E51A32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4931 7.85352H11.5051V17.6621H12.4931V7.85352Z",
    fill: "#E51A32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 4.90891H15.842L15.3971 4.25827C14.9718 3.68508 14.3072 3.29535 13.5593 3.18527C12.527 3.06297 11.508 3.06297 10.4261 3.1869C9.66223 3.30024 8.97727 3.70465 8.58917 4.27539L8.15587 4.90891H4.9978V5.82047H5.35579L6.0948 18.6141C6.13466 19.7189 7.03937 20.6305 8.24536 20.7772C9.48502 20.9256 10.7335 20.9998 11.9838 20.9998C13.2341 20.9998 14.4853 20.9256 15.7231 20.7772C16.9053 20.6346 17.8223 19.7279 17.9038 18.6214L18.6437 5.81966H18.9999V4.90891ZM9.42742 4.75563C9.65957 4.41156 10.1044 4.15554 10.5643 4.08786C11.5452 3.97616 12.4827 3.97453 13.4184 4.08624C13.8845 4.1539 14.3081 4.4034 14.5721 4.75563L14.6758 4.90891H9.32463L9.42742 4.75563ZM16.9141 18.5708C16.8671 19.2403 16.3106 19.789 15.5956 19.8754C13.1987 20.1625 10.7681 20.1625 8.37473 19.8754C7.66142 19.7898 7.10672 19.2329 7.08369 18.5741L6.34556 5.82129H17.6514L16.9141 18.5708Z",
    fill: "#E51A32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1652_1176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteAllIcon);
export default __webpack_public_path__ + "static/media/delete_all_icon.bce8e9a614f3ed3a408853469cf3d529.svg";
export { ForwardRef as ReactComponent };